import { useState } from 'react'
import { adminService } from 'core/services/adminService'
import { toast } from 'react-toastify'

import c from './assets/sass/trigger-item.module.scss'

const TRIGGER_LABELS = {
    NO_SITE_ID: { icon: '🆔', name: 'Не ввёл ID', desc: 'Через N мин после регистрации без siteId, повтор через cooldown' },
    DAILY_REWARD: { icon: '📅', name: 'Дейлик не забран', desc: 'Ежедневно в 17:00 МСК если приз не забран' },
    ENERGY_RESTORED: { icon: '⚡', name: 'Энергия восстановилась', desc: 'Когда энергия восстановилась до 100 после траты 20+' },
    INACTIVE_USER: { icon: '💤', name: 'Уходящие юзеры', desc: 'Цепочка каждые 3 дня неактивности, макс N сообщений' },
    SOCIAL_PROOF: { icon: '🔥', name: 'Социальное доказательство', desc: 'Пн и Чт — FOMO с динамическими числами кейсов' },
    NEW_TASK: { icon: '📋', name: 'Новое задание', desc: 'Если у юзера есть невыполненное активное задание' },
    NEW_LEADERBOARD: { icon: '🏆', name: 'Новый лидерборд', desc: 'Автоматически при старте нового еженедельного лидерборда' },
}

export const TriggerItem = ({ config, onEdit, onUpdate }) => {
    const [toggling, setToggling] = useState(false)
    const [testing, setTesting] = useState(false)

    const label = TRIGGER_LABELS[config.type] || { icon: '❓', name: config.type }

    const handleToggle = async () => {
        try {
            setToggling(true)
            await adminService.updateTriggerConfig(config.id, { isEnabled: !config.isEnabled })
            toast(config.isEnabled ? 'Триггер выключен' : 'Триггер включен', { type: 'success' })
            onUpdate()
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        } finally {
            setToggling(false)
        }
    }

    const handleTest = async () => {
        try {
            setTesting(true)
            const result = await adminService.testTrigger(config.id)
            toast(result.success ? 'Тестовое сообщение отправлено' : 'Не удалось отправить', {
                type: result.success ? 'success' : 'error'
            })
        } catch (error) {
            toast('Ошибка теста: ' + error.message, { type: 'error' })
        } finally {
            setTesting(false)
        }
    }

    return (
        <div className={c.component}>
            <div className={c.header}>
                <div className={c.info}>
                    <div className={c.typeRow}>
                        <span className={c.icon}>{label.icon}</span>
                        <span className={c.title}>{label.name}</span>
                    </div>
                    {label.desc && <span className={c.desc}>{label.desc}</span>}
                    <span className={c.meta}>
                        Приоритет: {config.priority} | Cooldown: {config.cooldownHours}ч | Макс цепочка: {config.maxSendsTotal || '∞'}
                    </span>
                    <span className={c.meta}>
                        Сообщений: {config.messageCount || 0} | Отправлено 24ч: {config.sent24h || 0} | Всего: {config.totalSent || 0}
                    </span>
                </div>
                <div className={c.toggle}>
                    <span className={c.toggleLabel}>{config.isEnabled ? 'Вкл' : 'Выкл'}</span>
                    <div
                        className={`${c.switchTrack} ${config.isEnabled ? c.active : ''}`}
                        onClick={toggling ? undefined : handleToggle}
                    >
                        <div className={c.switchThumb} />
                    </div>
                </div>
            </div>
            <div className={c.actions}>
                <button onClick={onEdit} className={c.editBtn}>
                    Редактировать
                </button>
                <button onClick={handleTest} disabled={testing} className={c.testBtn}>
                    {testing ? '...' : 'Тест'}
                </button>
            </div>
        </div>
    )
}
